import React from 'react'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import parser from 'html-react-parser'

export default function ContentBlocks4({data}) {
    const {contentBlocks4Title, contentBlocks4Blocks, contentBlocks4BackgroundColor } = data
    return (
        <div className={`ws-partner-wrap panel-space-70 light-${contentBlocks4BackgroundColor}-bg`}>
            <div className='container'>
                <div className='row'>
                    <div className='col-md-12'>
                        <h2 className='heading-level-2 blue-color text-center'>
                            {contentBlocks4Title && parser(contentBlocks4Title)}
                        </h2>
                    </div>
                </div>
                <div className='row'> 
                    {contentBlocks4Blocks.map((block, i) => (
                        <div className='col-md-4 ws-ex-col' key={i}>
                            <div className='ws-green-bx'>
                                <div className='ws-ex-image-pic'>
                                    <GatsbyImage
                                        image={getImage(
                                            block.contentBlocks4BlockImage.localFile
                                        )}
                                        alt='image'
                                    />
                                </div>
                                <div className='ws-ex-content'>
                                    <div className='heading-level-4-b black-color'>
                                        {block.contentBlocks4BlockTitle && parser(block.contentBlocks4BlockTitle)}
                                    </div>
                                    <p>{block.contentBlocks4BlockText && parser(block.contentBlocks4BlockText)}</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}
